import React from "react";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import logoSrc from "../AuthLayout/footerLogo.svg";
import compliantSrc from "../AuthLayout/compliant.svg";
import ncpaSrc from "../AuthLayout/ncpa.svg";
import fedexSrc from "../AuthLayout/fedex.png";
import { FollowUs } from "../../shared/FollowUs/FollowUs";
import Grid from "@mui/material/Grid";
export const Footer: React.FunctionComponent = () => {
  const items = [
    {
      title: 'COMPANY',
      routes: [
        { title: ' Home', path: 'https://www.tradenetrx.com' },
        { title: 'About Us', path: 'https://www.tradenetrx.com/about-us' },
        { title: 'Shipping ', path: 'https://www.tradenetrx.com/shipping' },
      ]
    },
    {
      title: 'GET HELP',
      routes: [
        { title: 'How it works', path: 'https://www.tradenetrx.com/how-it-works' },
        { title: 'FAQ', path: 'https://www.tradenetrx.com/faq' },
        { title: 'Contact Us', path: 'https://www.tradenetrx.com/contact-us' },
      ]
    }
  ]
  return (
    <Box sx={{ width: '100%', pt: 4 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', bgcolor: '#090808', color: '#FFFEFE', padding: '40px 0' }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Link href='https://www.tradenetrx.com' target='_blank' sx={{ color: '#FFFEFE' }} underline='none' variant="body2" >
                <img width={220} src={logoSrc} alt='logo' />
              </Link>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Link href='https://ncpa.org/' target='_blank' sx={{ color: '#FFFEFE' }} underline='none' variant="body2" >
                <img width={180} src={ncpaSrc} alt='ncpa' />
              </Link>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', justifyContent: 'space-around', flex: 0.3 }}>
              {items.map((item: any, index: number) => (
                <Box key={index}>
                  <Box key={index} sx={{ color: '#CCAF9B', mb: 2 }}>{item.title}</Box>
                  {item.routes.map((route: any, i: number) => (
                    <Box key={i} sx={{ mt: 1, cursor: 'pointer' }}>
                      <Link href={route.path} target='_blank' sx={{ color: '#FFFEFE' }} underline='none' variant="body2" >
                        {route.title}
                      </Link>
                    </Box>
                  ))}
                </Box>
              ))}
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Link href='https://www.tradenetrx.com/dscsa-compliant' target='_blank' sx={{ color: '#FFFEFE' }} underline='none' variant="body2" >
                <img width={220} src={compliantSrc} alt='logo' />
              </Link>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Link href='https://www.fedex.com/en-us/shipping/dropbox.html' target='_blank' sx={{ color: '#FFFEFE' }} underline='none' variant="body2" >
                <img width={150} height='Auto' src={fedexSrc} alt='fedex' />
              </Link>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <FollowUs borderTop={true} />
      <Box sx={{ background: 'rgba(29, 31, 33, 0.87)', color: '#FFFEFE', padding: '30px 0' }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              @2026 TradeNetRx. All Rights Reserved
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Link href='https://www.tradenetrx.com/privacy-policy' target='_blank' sx={{ color: '#FFFEFE', mr: 2 }} underline='none' variant="body2" >Privacy Policy</Link>
              /
              <Link href='https://www.tradenetrx.com/user-agreement' target='_blank' sx={{ color: '#FFFEFE', ml: 2 }} underline='none' variant="body2" >User Agreement</Link>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}